import React, { Suspense, lazy } from "react";
import { Spinner } from "react-bootstrap";
import { useSelector } from "react-redux";
import { RootState } from "redux/store";

const UK = lazy(() => import("../TermsOfWebsite"));
const IE = lazy(() => import("../Ireland/TermsOfWebsiteIE"));
const DK = lazy(() => import("../Denmark/TermsOfWebsiteDK"));
const PT = lazy(() => import("../Portugal/TermsOfWebsitePT"));

const TermsOfWebsiteLoader = () => {
    const region = useSelector((state: RootState) => state.region.region);

    return (
        <Suspense fallback={<Spinner animation="border" variant="light" />}>
            <>
                {region === "UK" && <UK />}
                {region === "IE" && <IE />}
                {region === "DK" && <DK />}
                {region === "PT" && <PT />}

            </>
        </Suspense>
    );
};

export default TermsOfWebsiteLoader;